import classNames from 'classnames/bind';
import { ReactNode } from 'react';
import styles from './Button.module.scss';
import Loader from '../Loader';
import Icon from '../Icon/Icon';
import { IconName } from '../Icon/utils/types';
import { Tooltip } from 'react-tippy';
import '../../styles/tippy.scss';

const cx = classNames.bind(styles);

export enum ButtonTheme {
  Light = 'light',
  Dark = 'dark',
}

export interface ButtonProps {
  children: ReactNode;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  theme?: ButtonTheme;
  icon?: IconName;
  onClick: () => void;
  tooltip?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
}

const Button = (props: ButtonProps) => {
  const {
    children,
    className,
    isLoading,
    disabled,
    theme = ButtonTheme.Dark,
    icon,
    onClick,
    tooltip,
    tooltipPosition = 'top',
  } = props;

  const handleClick = () => {
    if (disabled || isLoading) {
      return;
    }
    onClick();
  };

  const buttonContent = (
    <button
      type="button"
      aria-disabled={disabled}
      className={cx(
        'button',
        `button--${theme}`,
        {
          [`button--${theme}-disabled`]: disabled,
        },
        className
      )}
      onClick={handleClick}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <span className={cx('button--content')}>{children}</span>
      )}
      {icon && <Icon className={cx('button--icon')} name={icon} />}
    </button>
  );

  if (!tooltip) {
    return buttonContent;
  }

  return (
    <Tooltip title={tooltip} position={tooltipPosition} arrow={false}>
      {buttonContent}
    </Tooltip>
  );
};

export default Button;
